import { useState } from 'react';
// import './MainPage.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import MainScreen from '../../components/MainScreen';
import PreFooter from '../../components/PreFooter';
import Back from './bg.jpg';
import Popup from '../../components/Popup';

const MainPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <MainScreen
        title='Find Interim Leadership for Long-term Care Facilities'
        text='Connect with exceptional healthcare executives ready to step in and deliver results when you need them most.'
        beforeTags={['IMMEDIATE NEED FOR INTERIM LEADERSHIP?']}
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
        background={Back}
      />

      <div className='facilities'>
        <span className='blockTitle'>Facilities We Serve</span>
        <span className='blockText'>Specialized expertise across all long-term care environments.</span>
        <div className='facilitiesList'>
          <div className='facilitiesItem'>
            <span className='facilitiesItemIcon'>SNFs</span>
            <span className='facilitiesItemText'>Skilled Nursing Facilities</span>
          </div>

          <div className='facilitiesItem'>
            <span className='facilitiesItemIcon'>ALF</span>
            <span className='facilitiesItemText'>Assisted Living Facilities</span>
          </div>

          <div className='facilitiesItem'>
            <span className='facilitiesItemIcon'>IRFs</span>
            <span className='facilitiesItemText'>Inpatient Rehabilitation Facilities</span>
          </div>

          <div className='facilitiesItem'>
            <span className='facilitiesItemIcon'>LTCHs</span>
            <span className='facilitiesItemText'>Long-term Care Hospitals</span>
          </div>

          <div className='facilitiesItem'>
            <span className='facilitiesItemIcon'>PCFs</span>
            <span className='facilitiesItemText'>Palliative Care Facilities</span>
          </div>

          <div className='facilitiesItem'>
            <span className='facilitiesItemIcon'>MCCs</span>
            <span className='facilitiesItemText'>Memory Care Communities</span>
          </div>
        </div>
        <span className='facilitiesText'>Qualified candidates presented within 48 hours of engagement</span>
      </div>

      <div className='locumTags'>
        <div className='locumTagsContent'>
          <span className='blockTitle'>Access to In-Demand Talent</span>
          <span className='locumTagsTitle'>Community Level</span>
          <div className='locumTagsList'>
            <span className='locumTagsItem'>Executive Director</span>
            <span className='locumTagsItem'>Operations Manager</span>
            <span className='locumTagsItem'>Director of Revenue Cycle</span>
            <span className='locumTagsItem'>Director of Nursing</span>
            <span className='locumTagsItem'>Director of Accounting & Finance</span>
            <span className='locumTagsItem'>Wellness Director</span>
            <span className='locumTagsItem'>Nursing Home Administrator</span>
            <span className='locumTagsItem'>Director of Resident Services</span>
            <span className='locumTagsItem'>Infection Prevention</span>
            <span className='locumTagsItem'>Assisted Living Administrator</span>
            <span className='locumTagsItem'>Director of Community Relations</span>
            <span className='locumTagsItem'>MDS Coordinator</span>
            <span className='locumTagsItem'>Risk Management</span>
            <span className='locumTagsItem'>Director of Sales & Marketing</span>
            <span className='locumTagsItem'>Director of Human Resources</span>
          </div>
          <span className='locumTagsTitle'>Corporate Level</span>
          <div className='locumTagsList'>
            <span className='locumTagsItem'>Chief Executive Officer</span>
            <span className='locumTagsItem'>Chief Nursing Officer</span>
            <span className='locumTagsItem'>Vice President of Operations</span>
            <span className='locumTagsItem'>Chief Operating Officer</span>
            <span className='locumTagsItem'>Chief Human Resources Officer</span>
            <span className='locumTagsItem'>Vice President of Clinical</span>
            <span className='locumTagsItem'>Chief Financial Officer</span>
            <span className='locumTagsItem'>Vice President of Risk Management</span>
            <span className='locumTagsItem'>Vice President of Sales & Marketing</span>
            <span className='locumTagsItem'>Chief Clinical Officer</span>
            <span className='locumTagsItem'>Vice President of Revenue Cycle</span>
          </div>
        </div>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <PreFooter
        title='Ready to Find Your Next Leader?'
        text="Don't let leadership gaps compromise your facility's success. Connect with our expert team today and access the healthcare executives you need."
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
      />
      <Footer />
    </div>
  );
};

export default MainPage;
